<template>
  <div>
    <p class="mb-2">
      Product dimensions:
    </p>
    <PositionAndSize
      :h="height"
      :w="width"
      :x="x"
      :y="y"
      :is-open="isOpen"
      @toggleSection="toggleSectionHandler"
      @input="onChange"
    />
    <b-btn
      :disabled="isButtonDisabled"
      variant="primary"
      @click="onSave"
    >
      Save
    </b-btn>
    <b-btn
      variant="outline-primary"
      @click="onClose"
    >
      Cancel
    </b-btn>
  </div>
</template>

<script>
import PositionAndSize from "./components/PositionAndSize.vue";
import { editorControlEventBroker, EVENTS } from '@frontend/group/modules/editor-control-popup/event-broker'
export default {
  components: {
    PositionAndSize,
  },
  props: {
    isOpen: {
      type: Object,
      default: () => ({
        themeSection: true,
        borderSection: true,
        opacityAndScaleSection: true,
        actionSection: true,
        productSection: true,
        productSettingsSection: true,
        imageSettingsSection: true,
        outlineSettingsSection: true,
      }),
    },
    target: {
      type: Object,
      default: () => {
      },
    },
    options: {
      type: Object,
      default: () => {
      },
    },
  },

  computed: {
    height: function () {
      return this.target.fieldOptionChanges.Height;
    },
    width: function () {
      return this.target.fieldOptionChanges.Width;
    },
    x: function () {
      return this.target.fieldOptionChanges.X;
    },
    y: function () {
      return this.target.fieldOptionChanges.Y;
    },
    isButtonDisabled: function() {
      return this.target.fieldOptionChanges.isEqual;
    }
  },

  methods: {
    onChange(action, value) {
      editorControlEventBroker.fire(EVENTS.PRODUCT_DIMENSION_CHANGED, {
        action, value
      })
    },
    onSave() {
      this.onChange('save', null);
    },
    onClose() {
      this.onChange('close', null);
    },
    toggleSectionHandler(sectionKey) {
      this.$emit('toggleSection', sectionKey);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
